import { useCallback, useEffect, useState } from "react";
import { DropoffGate } from "../models/DropoffGate";
import PlotAPI from "../plotAPI";

interface useDropoffGatesProps {
    projects: any[];
    projectInfo: (projectId: string | number) => any | null;
}

const useDropoffGates = ({ projects, projectInfo }: useDropoffGatesProps) => {
    const [dropoffGatesByProject, setDropoffGatesByProject] = useState<
        { unique_token: string; dropoffGates: DropoffGate[] }[]
    >([]);

    const refreshDropoffGatesByProject = useCallback(() => {
        return Promise.all(
            projects.map((project) =>
                PlotAPI.getProjectDropoffGates(
                    project.claimed_by_team_subdomain || "projects",
                    project.unique_token,
                    project.timezone
                ).then((dropoffGates) => {
                    return {
                        unique_token: project.unique_token,
                        dropoffGates,
                    };
                })
            )
        ).then((dropoffGates) => {
            setDropoffGatesByProject(dropoffGates);
        });
    }, [projects]);

    useEffect(() => {
        refreshDropoffGatesByProject();
    }, [projects, refreshDropoffGatesByProject]);

    const dropoffGatesForProject = (projectId: string | number): DropoffGate[] => {
        const projectToken = projectInfo(projectId)?.unique_token;

        return dropoffGatesByProject.find((project) => project.unique_token === projectToken)?.dropoffGates || [];
    };

    return {
        dropoffGatesByProject,
        dropoffGatesForProject,
        refreshDropoffGatesByProject,
    };
};

export default useDropoffGates;
